import React from 'react'
import Globals from '../Globals'
import Editar from '../assets/img/botao-editar.svg'

function InputImage({ image, setImage, imageAvatar }) {

    return (
        <div style={{ position: 'relative', maxHeight:'200px', maxWidth: '200px' }}>
            {
                image.fileReal === '' ? image.file === null || (image.file === "" || image.file === undefined || image.file === null) ? <div className="image-client" > <img width={'100%'} alt='avatar' src={imageAvatar} /> </div> : <div className="image-client" style={{ backgroundImage: 'url(' + Globals.BASE_URL + '/storage/' + image.file + ')' }}></div> : <div className="image-client" style={{ backgroundImage: 'url(' + image.file + ')' }}></div>
            }
            <label style={{ cursor: 'pointer', background: 'rgb(187 187 187)', width: '32px', height: '32px', borderRadius: '50%', position: 'absolute', bottom: '10px', right: '15px' }} htmlFor="input-image">
                <img style={{ margin: '6px 7px', position: 'absolute', width: '20px', height: '20px' }} alt="editar imagem" src={Editar} />
            </label>

            <input id="input-image" accept="image/png, image/jpeg, image/jpg" style={{ display: 'none' }} type="file" onChange={(event) => {
                var key = 0

                for (; key < event.target.files.length; key++) {
                    if (event.target.files[key] === undefined) return

                    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg'];

                    if (!acceptedImageTypes.includes(String(event.target.files[key].type))) {
                        return;
                    }
                    setImage({
                        fileReal: event.target.files[key],
                        file: URL.createObjectURL(event.target.files[key])
                    })
                }

            }} />
        </div>
    )
}

export default InputImage;